<template>
 <div class="serve">
  <Header></Header>
  <div class="serve-content-pc">
   <Content></Content>
  </div>
  <div class="serve-content-mobile">
   <ContentMobile> </ContentMobile>

  </div>

 </div>
</template>

<script setup>
import Header from "./header.vue"
import Content from "./content.vue"
import ContentMobile from "./contentMobile.vue"
import { onMounted } from 'vue'



</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .serve-content-pc {
  display: none !important;
 }

 .serve-content-mobile {
  display: block;
 }
}

@media screen and (min-width: 800px) {
 .serve-content-pc {
  display: block !important;
 }

 .serve-content-mobile {
  display: none;
 }
}

.serve {
 width: 100%;
 height: 100%;

}

.serve-content-mobile {
 width: 100%;
 height: 100%;
}

.serve-content {}
</style>